var generateComponentTheme = function generateComponentTheme(_ref) {
  var typography = _ref.typography,
    breakpoints = _ref.breakpoints,
    transitions = _ref.transitions,
    spacing = _ref.spacing;
  return {
    fontFamily: typography.fontFamily,
    contentTransition: "transform ".concat(transitions.duration),
    userContentMargin: spacing.mediumSmall
  };
};
export default generateComponentTheme;